import { Button, notification } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { CodeResponse, useGoogleLogin } from "@react-oauth/google";
import { Provider, ProviderStatusResponse } from "../../../types/provider";
import { useGoogleReconnect } from "../../../queries/google";

interface GoogleReconnectButtonProps {
  provider: Provider & ProviderStatusResponse;
  refetchStatuses: () => void;
}

export const GoogleReconnectButton = ({
  provider,
  refetchStatuses,
}: GoogleReconnectButtonProps) => {
  const { t } = useTranslation();
  const { mutate: googleReconnect } = useGoogleReconnect({ refetchStatuses });

  const onSuccess = async (codeResponse: CodeResponse) => {
    const authCode = codeResponse.code;

    googleReconnect({ authCode, accountAddress: provider.accountAddress });
  };

  const onFailure = () => {
    notification.error({
      message: t("toast.failed-to-reconnect-provider"),
      description: t("toast.please-check-your-credentials"),
    });
  };

  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: onSuccess,
    onError: onFailure,
    scope: "https://www.googleapis.com/auth/calendar openid",
  });

  return (
    <Button
      style={{
        backgroundColor: provider.status === "error" ? "#60bc60" : undefined,
        color: provider.status === "error" ? "#ffffff" : "#60bc60",
        marginTop: "0.3rem",
      }}
      type={provider.status === "error" ? "primary" : "link"}
      onClick={(event) => {
        event.stopPropagation();
        googleLogin();
      }}
    >
      {t("pages.service-accounts.service-accounts-table.reconnect")}
    </Button>
  );
};
